import { Box, ContainerProps, FormHelperText } from '@chakra-ui/react';
import React, { FC } from 'react';
import { FieldErrors } from 'react-hook-form';
import ErrorMessageContainer from './ErrorMessageContainer';

interface ErrorMsgProps {
  dataTestId?: string;
  errors: FieldErrors;
  name: string;
  helperText?: string;
  errorTextStyles?: ContainerProps;
  helperTextStyles?: ContainerProps;
}

const FormFieldMeta: FC<ErrorMsgProps> = ({
  errors = {},
  name,
  helperText = '',
  helperTextStyles = {},
  errorTextStyles = {},
  dataTestId,
  ...props
}) => (
  <Box
    minH={6}
    {...props}
  >
    <ErrorMessageContainer
      errorDataTestId={`${dataTestId}-error`}
      errors={errors}
      mt={0}
      name={name}
      position='relative'
      {...errorTextStyles}
    />
    {!errors?.[name] && (
      <FormHelperText
        mt={0}
        {...helperTextStyles}
      >
        {helperText || ''}
      </FormHelperText>
    )}
  </Box>
);

export default FormFieldMeta;
